import React, {useState} from "react";

import ReactPaginate from "react-paginate";
import Icon from "../atoms/Icon";
import PaginationSelectBox from "./PaginationSelectBox";

const ListPaginationWithLimit = (props) => {
    // const [devicePerPage, setDevicePerPage] = useState(10)
    // console.log("PROPS PAGINATION: ",props)
    // Define the number of users per page
    // const userPerPage = 10;
    // Calculate the total number of pages based on the total count of users and users per page
    const pageCount = Math.ceil(props.countAll / props.devicePerPageLimit);
    // Calculate the start index of the displayed range
    const startIndex = (props.currentPage - 1) * props.devicePerPageLimit + 1;
    // Calculate the end index of the displayed range, ensuring it doesn't exceed the total count of users
    const endIndex = Math.min(startIndex + props.devicePerPageLimit - 1, props.countAll);
    if (props.countAll < props.devicePerPageLimit) {
        return null;
    }
    return (
        <div dir="ltr" className="w-full flex flex-row items-center justify-between  mt-8">
            <ReactPaginate
                breakLabel={"..."}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                forcePage={props.currentPage - 1}
                className="flex flex-row-reverse items-center  gap-2.5"
                pageCount={pageCount}
                previousLabel={<Icon iconName="arrow-rightD"/>}
                nextLabel={<Icon iconName="arrow-leftD"/>}
                onPageChange={props.changePage}
                pageClassName="rounded-full border-gray border-1 h-8.5 w-8.5 text-13 text-dark-blue-200 bg-gray-100"
                containerClassName={""}
                previousLinkClassName={
                    "rounded-full border-gray border-1 h-8.5 w-8.5 flex items-center justify-center text-13 text-dark-blue-200 bg-gray-100"
                }
                nextLinkClassName={
                    "rounded-full border-gray border-1 h-8.5 w-8.5 flex items-center justify-center text-13 text-dark-blue-200 bg-gray-100"
                }
                pageLinkClassName={"w-full text-center flex items-center justify-center h-full"}
                activeClassName={"border-1 border-blue "}
            />

            <div className={"flex flex-row justify-center items-center text-13 text-gray_L leading-5 word-spacing gap-2"} dir={"rtl"}>
                <p>
                    نمایش
                </p>
                <PaginationSelectBox
                    title={"انتخاب تعداد"}
                    label={"شیسیشس"}
                    options={[
                        {
                            "value": 10,
                            "label": "10 دستگاه"
                        },
                        {
                            "value": 20,
                            "label": "20 دستگاه"

                        },
                        {
                            "value": 30,
                            "label": "30 دستگاه"

                        },
                        {
                            "value": 40,
                            "label": "40 دستگاه"

                        },
                        {
                            "value": 50,
                            "label": "50 دستگاه"

                        }


                    ]}
                    selected={props.devicePerPageLimit}
                    onChange={(item) => {
                        props.onDevicePerPageChange(item.value)
                    }}

                />
                <p>
                     از {props.countAll} ردیف داده
                </p>


            </div>


        </div>
    );
};

export default ListPaginationWithLimit;
